import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable, reaction} from 'mobx'
import {isValidPhoneNumber} from 'libphonenumber-js'
import {post} from '../common/requester'
import Schedule from "./Schedule";
import Award from "./Award";

export default class Training extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      id: observable,
      class_date: observable,
      team_id: observable,
      participants: observable,
      was_validated: observable,
      award: observable,
      getAwardTypes: action,
      getAwards: action,
      createAward: action,
    })
    reaction(() => this.company_id, (cid) => {
      this.award.setContext({company_id: cid});
    });
  }

  id = 0;
  class_date = '';
  team_id = null;
  participants = [];
  was_validated = false;
  award = new Award(this);

  get is_valid() {
    return this.class_date && this.team_id;
  }

  validate = () => {
    this.was_validated = true;
    return this.is_valid;
  }

  async getAwardTypes({sport_id, scope = "TRAINING", include_common = true} = {}) {
    this.award.setTypeFilter({sport_id, scope, include_common});
    return this.award.getAwardTypes();
  }

  async getAwards(filters = {}) {
    return this.award.listAwards({team_class_id: this.team_class_id, ...filters});
  }

  async createAward(payload = {}) {
    return this.award.createAward({team_class_id: this.team_class_id, ...payload});
  }
}